import React, {useMemo, useState} from 'react';
import _ from 'lodash';
import {Container, Stack, Tab, Tabs, Typography, Box} from '@mui/material';
import withMainContainer from '../../components/WithMainContainer.js';
import {withLoginRequire} from '../../components/Login.js';
import {withPermGuard} from '../../components/PermGuard.js';
import { withTitle } from '../../title.js';


const RoomItem = props=>{

};

const RoomsEmptyState = props=>{

};

const RoomsGrid = props=>{

};

const RoomsTab = props=>{
    return <Stack direction="row" gap={2} flexWrap="wrap"
      justifyContent="center">
      
    </Stack>;
};

const SettingsTab = props=>{

};

const TABS = {
    ROOMS: {label: 'המפגשים שלי', Comp: RoomsTab},
    SETTINGS: {label: 'הגדרות', Comp: SettingsTab},
};

const TabsHeader = props=>{
    let {value, onChange} = props;
    let items = useMemo(()=>_.entries(TABS)
        .map(([k, v])=>({value: k, label: v.label})), []);
    return <Stack direction="row" gap={2} justifyContent="space-between"
      alignItems="center" flexWrap="wrap-reverse">
      <Box flexGrow={1} sx={{borderBottom: 1, borderColor: 'divider'}}>
        <Tabs value={value} onChange={(__, v)=>onChange(v)}>
          {items.map(item=><Tab key={item.value} {...item}/>)}]
        </Tabs>
      </Box>
    </Stack>;
};

const TarakoHost = ()=>{
    let [tab, setTab] = useState(_.keys(TABS)[0]);
    let Comp = TABS[tab].Comp;
    return <Container maxWidth="lg" sx={{marginTop: 4, marginBottom: 12}}>
      <Stack direction="column" gap={2}>
        <Typography textAlign="center" variant="h2">טראקו</Typography>
        <TabsHeader value={tab} onChange={setTab}/>
        <Comp/>
      </Stack>
    </Container>;
};

export default withTitle('אפליקציית המסרים', withMainContainer(
    withLoginRequire(withPermGuard(TarakoHost, 'tarako.host'))));
